import {page, queueParamCookies, queueSessionTrackingCookies} from '@commercial-website/analytics'
import {
    hasAdvertisingConsent,
    hubspotAPI,
    trackHubspotNavigation,
} from '@commercial-website/consent'
import {pushEvent} from '@commercial-website/observability'
import type {GatsbyBrowser} from 'gatsby'

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({location, prevLocation}) => {
    if (location.search) {
        queueParamCookies(new URLSearchParams(location.search), {
            hasAdvertisingConsent,
            onConsentChange: hubspotAPI.addPrivacyConsentListener,
        })
    }

    queueSessionTrackingCookies({
        hasAdvertisingConsent,
        onConsentChange: hubspotAPI.addPrivacyConsentListener,
    })

    // The page path without the locale segment, e.g. `/pricing` instead of `/en/pricing`
    const rawPath = `/${location.pathname.split('/').slice(2).join('/')}`

    page({
        rawPath,
    })

    // HubSpot's tracking script only reacts to full page loads, so tell it about client-side route
    // changes (page view + CTA targeting for the new URL). prevLocation is null on the initial render,
    // which initHubspot() and HubSpot itself already cover.
    if (prevLocation) {
        trackHubspotNavigation()
    }

    pushEvent('navigation', {
        url: location.pathname,
    })
}
